import Header from "components/Headers/Header";
import React from "react";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import { saveAs } from "file-saver";
import SocialMediaDownloadAble from "../../assets/img/custom/addpitcher.jpg";
import AdImg1 from "../../assets/img/custom/adImg1.jpg";
import AdImg2 from "../../assets/img/custom/adImg2.jpg";
import AdImg3 from "../../assets/img/custom/adImg3.jpg";
import AdImg4 from "../../assets/img/custom/image (3).png";
import AdImg5 from "../../assets/img/custom/image (4).png";
import athleteAd from "../../assets/img/custom/athleteAds1.jpg";

function AthletePostThisPage() {
  const downloadImage = (imageSrc, fileName) => {
    saveAs(imageSrc, fileName || "fhp-ad.jpg");
  };

  return (
    <>
      <Header />
      <Container fluid className="mt--4">
        {/* Main Header Banner */}
        <Card className="shadow border-0 rounded-4 overflow-hidden mb-4">
          <div className="bg-gradient-primary p-4 text-white">
            <span className="text-uppercase tracking-wider font-weight-600 text-white-50" style={{ fontSize: "10px", letterSpacing: "1.5px" }}>
              ATHLETE TOOLKIT
            </span>
            <h2 className="text-white mb-0 mt-1 font-weight-700">
              Promotional Ads & Media Assets
            </h2>
            <p className="text-white-50 mb-0 mt-2" style={{ fontSize: "0.95rem" }}>
              Help other fans learn about FansHelpPlayers! Download these promotional ads and share them on your social media. Thank you for all your support!
            </p>
          </div>
        </Card>

        {/* Primary Ad Section */}
        <Card className="shadow border-0 rounded-4 overflow-hidden mb-4 bg-white p-4">
          <Row className="align-items-center">
            <Col lg="6" className="mb-4 mb-lg-0">
              <h3 className="h3 text-dark font-weight-700 mb-3">
                Featured Social Media Ad
              </h3>
              <p className="text-muted" style={{ lineHeight: "1.6" }}>
                This is our featured promotional graphic. Post this ad to your Instagram, Twitter, Facebook, or WhatsApp status to get your fans excited about FHP!
              </p>
              <div className="mt-4">
                <Button
                  color="primary"
                  size="lg"
                  className="rounded-pill px-5 font-weight-700 shadow"
                  onClick={() => downloadImage(SocialMediaDownloadAble, "featured-fhp-ad.jpg")}
                >
                  <i className="fas fa-download mr-2"></i> Download Featured Ad
                </Button>
              </div>
            </Col>
            <Col lg="6">
              <div className="border rounded-4 overflow-hidden shadow-sm bg-light p-2">
                <img 
                  src={SocialMediaDownloadAble} 
                  alt="Featured Ad" 
                  className="img-fluid rounded-3" 
                  style={{ width: "100%", maxHeight: "400px", objectFit: "contain" }} 
                />
              </div>
            </Col>
          </Row>
        </Card>

        {/* Other Assets Gallery Grid */}
        <h3 className="h3 text-dark font-weight-700 mb-3 mt-5 px-2">
          <i className="fas fa-images mr-2 text-primary"></i> More Assets & Graphics
        </h3>
        
        <Row>
          {[
            { src: AdImg1, name: "ad-asset-1.jpg" },
            { src: AdImg2, name: "ad-asset-2.jpg" },
            { src: athleteAd, name: "ad-asset-3.jpg", fullWidth: true },
            { src: AdImg3, name: "ad-asset-4.jpg", fullWidth: true },
            { src: AdImg4, name: "ad-asset-5.jpg", fullWidth: true },
            { src: AdImg5, name: "ad-asset-6.jpg", fullWidth: true }
          ].map((item, idx) => (
            <Col key={idx} xs="12" lg={item.fullWidth ? "12" : "6"} className="mb-4">
              <Card className="shadow-sm border-0 rounded-4 overflow-hidden h-100 bg-white">
                <CardBody className="p-3 d-flex flex-column justify-content-between">
                  <div className="border rounded-3 overflow-hidden bg-light p-2 mb-3 text-center d-flex align-items-center justify-content-center" style={{ minHeight: "250px" }}>
                    <img 
                      src={item.src} 
                      alt={`Ad Asset ${idx + 1}`} 
                      className="img-fluid rounded-2"
                      style={{ maxHeight: item.fullWidth ? "450px" : "320px", width: "auto", objectFit: "contain" }}
                    />
                  </div>
                  <div className="d-flex justify-content-between align-items-center px-1">
                    <span className="text-muted font-weight-600" style={{ fontSize: "0.85rem" }}>
                      Asset #{idx + 1}
                    </span>
                    <Button 
                      color="outline-primary" 
                      size="sm" 
                      className="rounded-pill px-4"
                      onClick={() => downloadImage(item.src, item.name)}
                    >
                      <i className="fas fa-download mr-1"></i> Download
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Video Link Callout */}
        <Card className="shadow border-0 rounded-4 overflow-hidden mb-5 bg-gradient-success text-white p-4" style={{ background: "linear-gradient(87deg, #2dce89 0, #2dcecc 100%)" }}>
          <Row className="align-items-center text-center text-md-left">
            <Col md="8" className="mb-3 mb-md-0">
              <h4 className="h3 text-white mb-2 font-weight-700">
                <i className="fab fa-youtube mr-2"></i> Share Promotional Video
              </h4>
              <p className="text-white-50 mb-0" style={{ fontSize: "0.95rem" }}>
                Rather share a video link? Share this official FHP video link directly with your community.
              </p>
            </Col>
            <Col md="4" className="text-md-right text-center">
              <a 
                href="https://youtu.be/ixgnWEYgbPA" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="btn btn-neutral text-success rounded-pill px-4 font-weight-700 shadow"
              >
                Open Video Link
              </a>
            </Col>
          </Row>
        </Card>
      </Container>
    </>
  );
}

export default AthletePostThisPage;
